var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueTelInput',{ref:"root",attrs:{"inputOptions":{
    styleClasses: { 'invalid-answer': _vm.phone && !_vm.isValid },
    type: 'tel',
    placeholder: _vm.placeholder,
    required: _vm.required,
  },"styleClasses":{ 'invalid-answer': _vm.phone && !_vm.isValid }},on:{"blur":_vm.onBlur,"input":_vm.onPhoneChange,"validate":_vm.onValidateChange,"open":function($event){return _vm.$emit('open')},"close":function($event){return _vm.$emit('close')}},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})}
var staticRenderFns = []

export { render, staticRenderFns }